export default __webpack_public_path__ + "device_doorbell_elite.a87d06ea.png";